<template>
  <div class="grid">
    <ul
      class="tabs --bg-lightestgray list-bare +border-top +border-left +border-bottom +mg-bottom-none grid-cell size-1of3--lg"
    >
      <template v-for="tab in tabs">
        <li
          :class="
            `tabs__cell --left --semibold --large-copy +pd-sm ${tabClass(
              tab.active
            )}`
          "
          :key="tab.id"
          @click.stop.prevent.capture="toggle"
          :data-id="tab.id"
        >
          <div class="media --reverse --align-middle">
            <div class="media__figure icon">
              <svg class="icon__glyph" v-if="tab.icon">
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  :xlink:href="tab.icon"
                ></use>
              </svg>
            </div>
            <div class="media__body" data-faux-anchor="true">
              <a :href="'#' + tab.id">{{ tab.title }}</a>
            </div>
          </div>
        </li>
      </template>
    </ul>

    <div
      class="grid-cell size-3of5--lg +border-top +border-right +border-bottom"
    >
      <template v-for="tab in tabs">
        <div
          class="tab-body"
          :key="tab.id"
          :id="tab.id"
          v-if="tab.id"
          v-html="tab.copy"
          v-show="tab.active"
        ></div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tabs: {
      default: function() {
        return []
      }
    }
  },

  methods: {
    tabClass: function(isActive) {
      return isActive ? ' --is-active-left' : ''
    },

    toggle: function(event) {
      let tab = event.currentTarget
      let target = tab.getAttribute('data-id')
      let tabContainer = tab.parentNode

      // Set the Selected Tab as Active
      Array.prototype.forEach.call(tabContainer.children, function(tab) {
        tab.classList.remove('--is-active-left')
      })
      tab.classList.add('--is-active-left')

      // Hide all Content
      let tabWrapper = tabContainer.parentNode
      Array.prototype.forEach.call(
        tabWrapper.querySelectorAll('.tab-body'),
        function(tabBody) {
          tabBody.setAttribute('style', 'display:none;')
        }
      )

      // Show Selected Content
      let tabBody = document.querySelector('#' + target)
      if (tabBody) {
        tabBody.removeAttribute('style')
      }
    }
  }
}
</script>
